/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
import EditableText from 'material/embeds/editabletext/editabletext_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/embed/shared/storytitle/storytitle_styles';



/* ========== ~~~~~~~~~~ EMBED : STORYTITLE : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class StoryTitle extends Component {
    constructor(props) {
        super(props);
        this.prevCharAmount = 0;
        this.characterLimit = 150;
        this.state = { fontSize: 'standard' };
    }
    componentDidMount() {
        // this.validateText(this.props.contentTitle, getElementCSSProperty(document.querySelector('.embededitor .question .text'), 'height'));
        this.validateText(this.props.contentTitle);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.contentId !== this.props.contentId) this.validateText(this.props.contentTitle);
    }
    adjustFontSize = text => {
        const charAmount = text !== null ? text.length: '';
        let fontSize = 'standard';
        if ((charAmount >= 50) && (charAmount < 70)) { fontSize = 'medium'; }
        if ((charAmount >= 70) && (charAmount < 100)) { fontSize = 'large'; }
        if (charAmount >= 100) { fontSize = 'xlarge'; }
        this.setState({
            fontSize
        })
    };
    validateText = (text) => {
        this.adjustFontSize(text);
        if(text === null) { return null; }
        const isValid = this.props.isValid;
        if (text.length > 0 && !isValid) {
            this.props.setStoryProperty(this.props.contentId, 'isTitleValid', true)
        } else if ((text.length === 0 || text.length > this.characterLimit) && (isValid || isValid === null)) {
            this.props.setStoryProperty(this.props.contentId, 'isTitleValid', false)
        }
    };
    handleSelect = () => {
        if(!this.props.isValid) this.props.setStoryProperty(this.props.contentId, 'isTitleValid', null)
    };
    render() {
        const placeholderText = 'Type your headline here';
        return(
            <div  className={`storytitle ${this.props.classes.storytitle} valid-${this.props.isValid}`}>
                <h3 className={`text ${this.state.fontSize}`} >
                    <EditableText contentId={this.props.contentId}
                                  contentTitle={this.props.contentTitle}
                                  isEditable={this.props.isEditable}
                                  isOption={false}
                                  optionId={null}
                                  placeholder={placeholderText}
                                  onKeyUp={this.validateText}
                                  onBlur={this.validateText}
                                  onFocus={this.handleSelect}
                                  isSelected={true}
                                  preventEnter={true}
                                  characterLimit={this.characterLimit}
                                  validateText={this.validateText}
                    />
                </h3>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(StoryTitle);
